import { object } from "prop-types";

import AddressField from "./AddressField";
import DateField from "./DateField";
import NumberField from "./NumberField";
import PickerField from "./PickerField";
import TextField from "./TextField";
import UploadField from "./UploadField";

/**
 *
 * @param {object} props
 * @param {ExtendedField} props.field
 * @returns
 */
export default function ExtendedField(props) {
  if (props.field.type === "date") {
    return <DateField {...props} />;
  }

  if (props.field.type === "text") {
    return <TextField {...props} data-cy="ExtendedField_Text" />;
  }

  if (props.field.type === "number") {
    return <NumberField {...props} />;
  }

  if (props.field.type === "address") {
    return <AddressField {...props} />;
  }

  if (props.field.type === "picker") {
    return <PickerField {...props} data-cy="ExtendedField_Picker" />;
  }

  if (props.field.type === "file") {
    return <UploadField {...props} />;
  }

  ExtendedField.propTypes = { field: object };

  return null;
}
